"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var FormikExtendedHandlers_1 = __importDefault(require("../FormikExtendedHandlers"));
function FormikExtended(_a) {
    var children = _a.children, enableReinitialize = _a.enableReinitialize, initialErrors = _a.initialErrors, initialTouched = _a.initialTouched, initialValues = _a.initialValues, initialStatus = _a.initialStatus, isInitialValid = _a.isInitialValid, onBeforeChange = _a.onBeforeChange, onFormReleased = _a.onFormReleased, onSave = _a.onSave, onSubmit = _a.onSubmit, translator = _a.translator, validate = _a.validate, validateOnBlur = _a.validateOnBlur, validateOnChange = _a.validateOnChange, validationFastest = _a.validationFastest, validationSchema = _a.validationSchema, ext = __rest(_a, ["children", "enableReinitialize", "initialErrors", "initialTouched", "initialValues", "initialStatus", "isInitialValid", "onBeforeChange", "onFormReleased", "onSave", "onSubmit", "translator", "validate", "validateOnBlur", "validateOnChange", "validationFastest", "validationSchema"]);
    tiny_invariant_1.default(children && typeof children === 'function', 'FormikExtended requires prop `children` to be a function.');
    var _b = __read(react_1.default.useState({
        dirty: false,
        errors: initialErrors || {},
        isSubmitting: false,
        isValid: isInitialValid !== null && isInitialValid !== void 0 ? isInitialValid : true,
        isValidating: false,
        status: initialStatus,
        touched: initialTouched || {},
        values: initialValues,
    }), 2), formState = _b[0], setFormState = _b[1];
    react_1.default.useEffect(function () {
        if (enableReinitialize) {
            setFormState(function (prev) { return (__assign(__assign({}, prev), { errors: initialErrors || {}, isValid: isInitialValid !== null && isInitialValid !== void 0 ? isInitialValid : true, touched: initialTouched || {}, values: initialValues })); });
        }
    }, [enableReinitialize, initialErrors, initialTouched, initialValues, isInitialValid]);
    var resetForm = react_1.default.useCallback(function () {
        setFormState(function (prev) { return (__assign(__assign({}, prev), { errors: initialErrors || {}, isValid: isInitialValid !== null && isInitialValid !== void 0 ? isInitialValid : true, touched: initialTouched || {}, values: initialValues })); });
    }, [initialErrors, initialTouched, initialValues, isInitialValid]);
    return (react_1.default.createElement(FormikExtendedHandlers_1.default, __assign({ formState: formState, setFormState: setFormState, onBeforeChange: onBeforeChange, onFormReleased: onFormReleased, onSave: onSave, onSubmit: onSubmit, resetForm: resetForm, translator: translator, validate: validate, validateOnBlur: validateOnBlur, validateOnChange: validateOnChange, validationFastest: validationFastest, validationSchema: validationSchema }, ext), children));
}
exports.default = FormikExtended;
FormikExtended.displayName = 'FormikExtended';
//# sourceMappingURL=FormikExtended.js.map